import React, { useMemo, memo } from "react";
import GaugeChart from "react-gauge-chart";
import { Chip } from "@mui/material";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const AQIKPI = memo(({ avgAQI, maxAQI, minAQI }) => {

// Good: 3, Moderate: 2 and Poor: 1

const percentage = useMemo(()=>{
  
  if (avgAQI > 100 &&avgAQI<= 500) return 0.2;
  if (avgAQI > 50 && avgAQI <= 100) return 0.5;
  if (avgAQI >= 0 && avgAQI <= 50) return 0.8;
  
  return 0.2; 

},[avgAQI])
  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        arcsLength={[0.1,0.1,0.1]}
        colors={["red","yellow","#82f61d"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage }
        hideText={true}
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgAQI}</span>
      <p className="card-value">Air Quality</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max" color="default" sx={chipStyle} />
          <p className="m-1 p-0">{maxAQI}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min" sx={chipStyle}  />
          <p className="m-1 p-0">{minAQI}</p>
        </div>
      </div>
    </>
  );
});

export default AQIKPI;
